export const shouldShowContentfulTools = profile =>
  (profile.role === 'admin' || profile.role === 'contentAdmin') &&
  profile.showContentfulTools === true;
